export const getQueryParamFromSearch = (search: string, param: string) => {
  const urlSearchParams = new URLSearchParams(search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return params[param];
};
